/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Action, AnyAction, Dispatch, MiddlewareAPI } from 'redux';
import { CustomMiddleware } from './redux-thunk-helper';
// import { setSideBarExpandedPanel, ExpansionName } from '../actions/side-bar';
import { initialStage, ITSEventType, ItsLoggerEvent } from 'its-pages';
import { logEvent, problemLoaded, setStage } from '../actions/ui';
import { postBugReport } from './api';
import { setSkillBarName } from '../actions/skill-bar';
import { State } from '../state';

/**
 *  The function that listens for and dispatches actions
 *  relevant to the embedding API.
 */
 const uiMiddleware = <S extends Dispatch<AnyAction>>(store: MiddlewareAPI<S>) => (
  next: Dispatch<AnyAction>
) => <A extends Action>(action: A) => {
    // (boilerplate) Call the next dispatch method in the middleware chain.
    const returnValue = next(action);
    const state = store.getState() as State;

    if (logEvent.match(action)) {
      const { payload: { eventType } } = action;
      if (eventType === ITSEventType.bugReport) {
        const { userId } = state.ui;
        const { cid, activityId, sessionId } = state.progression;
        const event: ItsLoggerEvent = {
          ...action.payload,
          uid: userId ?? "",
          cid,
          activityId,
          sessionId
        };
        postBugReport(event);
      }
    } else if (problemLoaded.match(action)) {
      const { pageContent } = state.currentProblemState;

      if (pageContent) {
        const pageData = pageContent.pageData;
        const type = pageData.type;
        const stage = initialStage(type);
        store.dispatch(setStage(stage));
        store.dispatch(setSkillBarName(pageData.skill.name));
        pageData.recordEvent(ITSEventType.problemLoad);
      }
    }

    // (boilerplate) This will likely be the action itself, unless
    // a middleware further in chain changed it.
    return returnValue;
  };

/**
 * Create middleware that handles actions related to the Embedding API
 * (which allows running games inside the Copilot Student Client)
 * @param store Redux store
 */
 export const createUIMiddleware: CustomMiddleware = <D extends Dispatch<AnyAction>>(
  store: MiddlewareAPI<D>
) => {
  // Return the function that listens for and dispatches actions
  // relevant to the embedding API.
  return uiMiddleware(store);
};
